import React from "react";
import { Row, Col, Image, Carousel } from 'react-bootstrap';

import PortraitItems from "../localdata/portraitCarouselItems.json";

export default function History() {
  
  return (
      <React.Fragment>
            <Row>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <h4>History</h4>
                <p>Born in 1940 the third of eight children, my formative education was at building and architecture college and became a self-employed builder in the late 1960's.</p>
                <p>By the mid 1970's I felt ready for a fresh challenge and sought it using a natural drawing ability that was evident from an early age.</p>
                <p>The initial idea was to encourage people to commission me to draw their childrens's portraits backed by a portfolio of portraits of personalities of the time plus those of his son and daughter.</p>
                <p>Interest generated was encouraging but commissions were few so the idea was abandoned in favour of animal portraiture using a unique medium called&nbsp;
                  <a href="https://en.wikipedia.org/wiki/Scratchboard" target="_blank" rel="noopener noreferrer">Scraperboard</a>.</p>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Carousel style={{ height: '450px' }}>
                { PortraitItems.map((item, i) => (
                   <Carousel.Item key={"portrait_slide_" + i}>
                      <img src={"/images/history/portraits/" + item.filename } alt={item.title} />
                      <Carousel.Caption>
                        <p className="small">{ item.description }</p>
                      </Carousel.Caption>
                   </Carousel.Item>
                  ))
                }
                </Carousel>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <Carousel style={{ height: '350px' }}>
                  <Carousel.Item>
                    <img src={"/images/history/crufts/firstCrufts.jpg"} alt="First Crufts Press Release" />
                    <Carousel.Caption><p className="small">First Crufts Press Release</p></Carousel.Caption>
                  </Carousel.Item>
                  <Carousel.Item>
                    <img src={"/images/history/crufts/exhibition.jpg"} alt="Exhibiting at Crufts" />
                    <Carousel.Caption><p className="small">Manchester Exhibition</p></Carousel.Caption>
                  </Carousel.Item>
                  <Carousel.Item>
                    <img src={"/images/history/crufts/angelaRipponSigning.jpg"} alt="Angela Rippon Signing" />
                    <Carousel.Caption><p className="small">Angela Rippon signing her portrait at Crufts</p></Carousel.Caption>
                  </Carousel.Item>

                </Carousel>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <p>Russell Prints was formed and a small portfolio of Dog scraperboard prints immediately drew interest. The breakthrough came when exhibiting for the first time at the Cruft's dog show bringing exposure of my work to people from all over the world.</p>
                <p>More than 2,000 prints were sold in the two days and within weeks the business had established agents in fourteen different countries.</p>
                <p>I went on to exhibit at Crufts for twenty years, the Ideal Home Exhibition for six and over this time expanded the portfolio of prints to every known breed of Dog,
                  a pencil range and many other subjects. Stockists of the prints even included London's Harrods.</p>
              </Col>
            </Row>

            <Row className="my-4" >
              <Col xs={12} sm={12} md={6} lg={3} xl={3}>
                <p>In 1991 I had the honour of being commissioned by the owners of <a href="https://en.wikipedia.org/wiki/Desert_Orchid" target="_blank" rel="noopener noreferrer">Desert Orchid</a> to produce a commemorative scraperboard
                engraving that would be used on all official 'Dessie' fan club merchandise.</p>
                <p>Finally in 2010 I sold the Russell Prints business and catalogue, retiring to draw and paint for fun in the small East Yorkshire coastal town of Hornsea.</p>
              </Col>
              <Col xs={12} sm={12} md={6} lg={5} xl={5}>
                <Image src="/images/history/desert_orchid.jpg" fluid></Image>
              </Col>
              <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                <Image className="pt-4 pt-md-0" src="/images/history/award2.jpg" fluid></Image>
              </Col>
            </Row>

      </React.Fragment>
    );
}
